import { Input } from "@/components/ui/input";
import { Textarea } from "@/components/ui/textarea";
import { TYPE_FAMILIES, slug } from "@/lib/questionTypes";

const FIELDS = [
  ["title", "Page title", "“ | QuestionGod” is added automatically", Input],
  ["subtitle", "Subtitle", "plain-language line under the type name", Input],
  ["seo", "SEO description", "search results & link previews", Textarea],
  ["intro", "Page intro", "", Textarea],
  ["invitation", "The invitation", "highlighted panel above the questions", Textarea],
];

export function TypePagesEditor({ pages, onChange }) {
  const set = (t, k, v) => onChange({ ...pages, [t]: { ...(pages[t] || {}), [k]: v } });
  return (
    <section className="space-y-4 rounded-2xl border border-border bg-card p-5" data-testid="settings-type-pages">
      <h2 className="font-serif text-2xl font-semibold text-foreground">Question type pages</h2>
      <p className="text-sm text-muted-foreground">Copy for each /type page, grouped by family.</p>
      {TYPE_FAMILIES.map((f) => (
        <div key={f.id} className="space-y-2">
          <p className="pt-2 font-mono text-xs uppercase tracking-[0.2em] text-gold">{f.name}</p>
          {f.types.map(({ name }) => (
            <details key={name} className="rounded-xl border border-border p-4" data-testid={`settings-type-page-${slug(name)}`}>
              <summary className="cursor-pointer font-semibold text-foreground">{name}</summary>
              <div className="mt-3 space-y-3">
                {FIELDS.map(([k, label, hint, C]) => (
                  <label key={k} className="block">
                    <span className="font-mono text-[10px] uppercase tracking-wider text-muted-foreground">{label}{hint && ` · ${hint}`}</span>
                    <C className="mt-1" rows={3} value={pages[name]?.[k] || ""} onChange={(e) => set(name, k, e.target.value)} data-testid={`settings-type-${slug(name)}-${k}`} />
                  </label>
                ))}
              </div>
            </details>
          ))}
        </div>
      ))}
    </section>
  );
}
